import { accountSchema } from '@juvare/contact-management/backend/features/accounts/shared/entities/accountTypes';
import { extendedAddressSchema } from '@juvare/credentialing/backend/features/person-credentials/entities/types';
import { defineColumns, EntityColumns } from '@juvare/platform-shared/features/storage';
import { zodKnownFieldDefaultValidation } from '@juvare/platform-shared/features/validation';
import { z } from 'zod';
import { backgroundCheckStatusesSchema, backgroundCheckTypesSchema } from '../../types';

export const backgroundCheckEntityName = 'backgroundCheck';

export const accountBackgroundCheckSchema = z.object({
    esarVhpId: z.string().max(zodKnownFieldDefaultValidation.stringMax).optional(),
    backgroundCheck: z
        .record(
            backgroundCheckTypesSchema,
            z.object({
                status: backgroundCheckStatusesSchema,
                updatedAt: z.number().optional(),
            }),
        )
        .refine(zodKnownFieldDefaultValidation.recordRefineCondition, zodKnownFieldDefaultValidation.recordRefineErrorMessage)
        .optional(),
    primaryBackgroundCheckStatus: backgroundCheckStatusesSchema.optional(),
    primaryBackgroundCheckType: backgroundCheckTypesSchema.optional(),
    primaryBackgroundUpdatedAt: z.number().optional(),
    consentBackgroundCheck: z.boolean().optional(),
    firstName: z.string().max(zodKnownFieldDefaultValidation.stringMax),
    lastName: z.string().max(zodKnownFieldDefaultValidation.stringMax),
    email: z.string().max(zodKnownFieldDefaultValidation.stringMax),
    dateOfBirth: z.string().max(zodKnownFieldDefaultValidation.stringMax).optional(),
    address: extendedAddressSchema.optional(),
    stateOfWork: z.string().max(zodKnownFieldDefaultValidation.stringMax).optional(),
    internalBackgroundCheckChange: z
        .object({
            isManualChange: z.boolean().optional(),
            type: backgroundCheckTypesSchema,
            status: backgroundCheckStatusesSchema,
            updatedAt: z.number(),
        })
        .optional(),
    lastContactedAt: z.number().optional(),
    recalculatePrimaryBackgroundCheckStatus: z.boolean().optional(),
});
export const accountWithBackgroundCheckSchema = accountSchema.merge(accountBackgroundCheckSchema);
export type BackgroundCheckData = z.infer<typeof accountWithBackgroundCheckSchema>;

export const backgroundCheckColumns = defineColumns({
    esarVhpId: {
        type: 'string',
        index: 'unique',
    },
    backgroundCheckTypeStatus: {
        type: 'string-array-required', // stored as ${type}_${status}
        index: true,
    },
    primaryBackgroundCheckStatus: {
        type: 'string',
        index: true,
    },
    primaryBackgroundCheckType: {
        type: 'string',
        index: true,
    },
    primaryBackgroundUpdatedAt: {
        type: 'number',
        index: true,
    },
    stateOfWork: {
        type: 'string',
        index: true,
    },
    consentBackgroundCheck: {
        type: 'boolean',
        index: true,
    },
});
export type BackgroundCheckColumns = EntityColumns<typeof backgroundCheckColumns>;
